export default "__VITE_ASSET__DTFjMTIc__"